// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const JobPostingsPage = lazy(() => import('./pages/JobPostingsPage'));
const ApplicantsPage = lazy(() => import('./pages/ApplicantsPage'));
const InterviewsPage = lazy(() => import('./pages/InterviewsPage'));
const OffersPage = lazy(() => import('./pages/OffersPage'));
const OnboardingPage = lazy(() => import('./pages/OnboardingPage'));
const OffboardingPage = lazy(() => import('./pages/OffboardingPage'));
const RecruitingAnalyticsPage = lazy(() => import('./pages/RecruitingAnalyticsPage'));

export const RecruitingRoutes: RouteObject = {
  path: 'recruiting',
  element: <ModuleGuard moduleId="people.recruiting" />,
  handle: { crumb: 'Recruiting & Onboarding' },
  children: [
    { index: true, element: <Navigate to="job-postings" replace /> },
    { path: 'job-postings', element: <JobPostingsPage />, handle: { crumb: 'Job Postings' } },
    { path: 'applicants', element: <ApplicantsPage />, handle: { crumb: 'Applicants' } },
    { path: 'interviews', element: <InterviewsPage />, handle: { crumb: 'Interviews' } },
    { path: 'offers', element: <OffersPage />, handle: { crumb: 'Offers' } },
    { path: 'onboarding', element: <OnboardingPage />, handle: { crumb: 'Onboarding' } },
    { path: 'offboarding', element: <OffboardingPage />, handle: { crumb: 'Offboarding' } },
    { path: 'recruiting-analytics', element: <RecruitingAnalyticsPage />, handle: { crumb: 'Recruiting Analytics' } },
  ],
};
